import { UserTheme } from '../../theme/api/types';
import { useGetTenantDataByRole } from '../../../features/tenant/hooks/useGetTenantDataByRole';

export const useUserTheme = () => {
    const { data: tenant, isLoading } = useGetTenantDataByRole();
    const coloringScheme = tenant?.coloringScheme || UserTheme.GREEN;

    return { theme: coloringScheme, isLoading };
};
